import { render, staticRenderFns } from "./historico-card.vue?vue&type=template&id=7f8de453&"
import script from "./historico-card.vue?vue&type=script&lang=js&"
export * from "./historico-card.vue?vue&type=script&lang=js&"
import style0 from "./historico-card.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports